module.exports = __webpack_public_path__ + "static/img/7.254b553.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/7.png
// module id = zPgU
// module chunks = 0